export default class SustainabilityIndexUtility {
    /**
     * Get the URL to the sustainability index document will prioritize PDF and fallback to SVG.
     *
     * @param product The product.
     * @returns The URL to the sustainability index document, or null if not found.
     */
    static getDocumentUrl(product, labelType) {
        return (this.getDocumentUrlByFileType(product, 'pdf', labelType) ??
            this.getDocumentUrlByFileType(product, 'svg', labelType));
    }
    /**
     * Get the URL to the sustainability index document with a specific fileType.
     *
     * @param product The product.
     * @param fileType The specific fileType of the document.
     * @returns The URL to the sustainability index document, or null if not found.
     */
    static getDocumentUrlByFileType(product, fileType, labelType) {
        return (product.content?.complianceLabel?.find((label) => label.labelType === labelType && label.fileType === fileType)?.url ?? null);
    }
    /**
     * Get the URL to the sustainability index image. Will prioritize SVG and fallback to PNG.
     *
     * @param product The product.
     * @returns The URL to the sustainability index image, or null if not found.
     */
    static getImageUrl(product, labelType) {
        return (this.getImageUrlByFileType(product, 'svg', labelType) ??
            this.getImageUrlByFileType(product, 'png', labelType));
    }
    /**
     * Get the URL to the sustainability index image with a specific fileType.
     *
     * @param product The product.
     * @param fileType The specific fileType of the image.
     * @returns The URL to the sustainability index image, or null if not found.
     */
    static getImageUrlByFileType(product, fileType, labelType) {
        return (product.content?.complianceLabel?.find((label) => label.labelType === labelType && label.fileType === fileType)?.url ?? null);
    }
    /**
     * Get an alt text which represents the sustainability index.
     *
     * @param product The product.
     * @returns An alt text.
     */
    static getImageAltText(product, headingType) {
        const sustainabilityIndex = product.content?.complianceTechnical?.find((item) => item.headingType === headingType);
        if (!sustainabilityIndex) {
            return '';
        }
        return `${sustainabilityIndex.headingText}: ${sustainabilityIndex.text}`;
    }
}
//# sourceMappingURL=SustainabilityIndexUtility.js.map